/// <reference path="../../../ui/types.d.ts" />
import { useEffect, useRef } from 'react';

const validateWidgetValue = (value: any) => {
    if (Array.isArray(value)) {
        return value;
    }

    if (typeof value === 'string') {
        try {
            return JSON.parse(value);
        } catch (e) {
            return [];
        }
    }

    return [];
};

const CrowdinFilesWidget = (props: any) => {
    const { id, label, value, onChange, required } = props;
    const filesData = props?.schema?.data || [];
    const crowdinFilesRef = useRef<any>(null);

    useEffect(() => {
        const crowdinFiles = crowdinFilesRef.current;

        if (crowdinFiles) {
            crowdinFiles.setAttribute('is-loading', true);
            crowdinFiles.setFilesData(filesData);
            crowdinFiles.setAttribute('is-loading', false);
        }
    }, [filesData]);

    useEffect(() => {
        const validatedValue = validateWidgetValue(value);
        const crowdinFiles = crowdinFilesRef.current;
        if (crowdinFiles && validatedValue?.length > 0) {
            crowdinFiles.setSelected(validatedValue);
        }
    }, [value]);

    useEffect(() => {
        const crowdinFiles = crowdinFilesRef.current;

        const handleSelectedChange = (event: any) => {
            if (event.detail.componentId === id) {
                const selectedFileIds = event.detail.selectedFiles.map((file: any) => file.id) || [];

                if (required && selectedFileIds?.length <= 0) {
                    onChange(undefined);
                    return;
                }
                onChange(JSON.stringify(selectedFileIds));
            }
        };

        if (crowdinFiles) {
            crowdinFiles.addEventListener('crowdinFilesSelectedChanged', handleSelectedChange);
        }

        return () => {
            if (crowdinFiles) {
                crowdinFiles.removeEventListener('crowdinFilesSelectedChanged', handleSelectedChange);
            }
        };
    }, [onChange]);

    return (
        <div>
            {label && <crowdin-h5 htmlFor={id}>{label || 'Select a file'}</crowdin-h5>}
            <crowdin-files-component
                id={id}
                ref={crowdinFilesRef}
                onfilechange={(event: any) => onChange(event.detail.files)}
            />
        </div>
    );
};

export default CrowdinFilesWidget;
